import { render } from "./AltAzDisplay.vue?vue&type=template&id=210590d5&scoped=true"
import script from "./AltAzDisplay.vue?vue&type=script&lang=js"
export * from "./AltAzDisplay.vue?vue&type=script&lang=js"

import "./AltAzDisplay.vue?vue&type=style&index=0&id=210590d5&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-210590d5"]])

export default __exports__